import { QuestionCircleOutlined } from '@ant-design/icons'
import { Button, Empty, message, Modal } from 'antd'
import { inject, observer } from 'mobx-react'
import queryString from 'query-string'
import React, { useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { blue } from '../../color'
import { Pen2OutlineIcon, TrashBin2OutlineIcon } from '../../components/AppIcon'
import { AppTable } from '../../components/AppTable/AppTable'
import { AppTablePagination } from '../../components/AppTable/AppTablePagination'
import AssetTypeRequest from '../../requests/AssetTypeRequest'
import ManagementAssetWarehouseUnitUpdate from './ManagementAssetWarehouseUnitUpdate'

const { confirm } = Modal

const ManagementAssetWarehouseUnitTable = props => {
  const [isVisibleUpdateModal, setIsVisibleUpdateModal] = useState(false)
  const [selectedTemplateId, setSelectedTemplateId] = useState(null)

  const {
    managementAssetWarehouseStore,
    isLoading,
    setIsLoading,
    handleRefreshData,
  } = props
  const {
    managementAssetTypes,
    totalAssetTypes,
  } = managementAssetWarehouseStore

  const history = useHistory()
  const location = useLocation()

  const queryStringParse = useMemo(
    () =>
      queryString.parse(location.search, {
        arrayFormat: 'index',
      }),
    [location.search]
  )

  const handleChangePagination = (pageIndex, size) => {
    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        page: pageIndex - 1,
        size: size,
      },
      {
        skipNull: true,
      }
    )
    history.push(
      `/manager-inventory/manage-inventory-asset?${queryStringStringify}`
    )
  }

  const handleOpenUpdateModal = id => {
    setIsVisibleUpdateModal(true)
    setSelectedTemplateId(id)
  }

  const handleCancelUpdateModal = () => {
    setIsVisibleUpdateModal(false)
  }

  const handleDelete = async id => {
    setIsLoading(true)
    try {
      await AssetTypeRequest.deteleAssetType(id)
      if (handleRefreshData) {
        await handleRefreshData()
      }
      message.success('Đã xóa!')
    } catch (err) {
      message.error('Loại văn phòng phẩm đã được sử dụng, không thể xóa!')
    } finally {
      setIsLoading(false)
    }
  }

  const showConfirm = (e, id) => {
    e.stopPropagation()
    setIsVisibleUpdateModal(false)
    confirm({
      title: 'Bạn có chắc chắn muốn xóa loại văn phòng phẩm này ?',
      icon: <QuestionCircleOutlined style={{ color: 'red' }} />,
      okText: 'Xóa',
      cancelText: 'Không',
      okType: 'danger',
      onOk: () => handleDelete(id),
    })
  }

  const tableColumns = [
    {
      title: 'STT',
      width: 50,
      render: (id, record, index) => index + 1,
    },
    {
      title: 'Loại văn phòng phẩm',
      width: 200,
      render: record => (
        <p
          style={{
            marginBottom: '0px',
          }}>
          {record?.description}
        </p>
      ),
    },
    {
      title: 'Ngày tạo',
      width: 50,
      render: record => {
        const date = new Date(record?.createAt || 0)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')

        const formattedDate = `${day}/${month}/${year}`
        return <p style={{ marginBottom: '0px' }}>{formattedDate}</p>
      },
    },
    {
      title: 'Thao tác',
      width: 50,
      align: 'center',
      //ignore onRow event
      onCell: record => {
        return {
          onClick: event => {
            event.stopPropagation()
          },
        }
      },
      render: record => (
        <div>
          <Button
            shape="circle"
            type="text"
            icon={
              <Pen2OutlineIcon
                style={{
                  width: '16px',
                  height: '16px',
                  color: blue,
                }}
                onClick={() => handleOpenUpdateModal(record.id)}
              />
            }
          />
          <Button
            shape="circle"
            type="text"
            icon={
              <TrashBin2OutlineIcon
                style={{ color: '#fc0000', width: '16px', height: '16px' }}
                onClick={e => showConfirm(e, record.id)}
              />
            }
          />
        </div>
      ),
    },
  ]

  return (
    <>
      <AppTable
        rowKey={record => record.id}
        dataSource={managementAssetTypes}
        columns={tableColumns}
        onRow={record => ({
          onClick: () => handleOpenUpdateModal(record.id),
        })}
        pagination={false}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={'Không có dữ liệu'}
            />
          ),
        }}
        loading={isLoading}
      />

      <AppTablePagination
        onChange={handleChangePagination}
        total={totalAssetTypes}
        pageSize={Number(queryStringParse?.size || 10)}
        current={Number(queryStringParse?.page || 0) + 1}
      />

      <Modal
        width={600}
        wrapClassName="custom-modal-wrapper"
        title={'Chỉnh sửa loại văn phòng phẩm'}
        visible={isVisibleUpdateModal}
        maskClosable={false}
        onCancel={handleCancelUpdateModal}
        footer={null}
        destroyOnClose>
        {isVisibleUpdateModal && (
          <ManagementAssetWarehouseUnitUpdate
            onCancel={handleCancelUpdateModal}
            templateId={selectedTemplateId}
            onUpdateSuccess={handleRefreshData}
          />
        )}
      </Modal>
    </>
  )
}

export default inject(
  'managementAssetWarehouseStore',
  'authenticationStore',
  'selectPeopleStore'
)(observer(ManagementAssetWarehouseUnitTable))
